import useUserQr from '@/hooks/useUserQr'
import { useEffect } from 'react'
import styled from 'styled-components'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens.js'
import QRCode from 'qrcode.react'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'

const UserQrVcard = () => {
  const { fetchUserQr, userQrLoading, userQr } = useUserQr()

  useEffect(() => {
    fetchUserQr()
  }, [])

  return (
    <>
      {userQrLoading ? (
        <CustomLoading />
      ) : (
        <Wrapper>
          <Image src={icons.QR_BORDER}></Image>
          <QRContainer>
            <QRCode
              size={512}
              level='H'
              includeMargin
              bgColor='transparent'
              style={{
                height: 'auto',
                width: '100%',
                borderRadius: '16px',
              }}
              value={userQr}
              viewBox={`0 0 256 256`}
            />
          </QRContainer>
        </Wrapper>
      )}
    </>
  )
}

export default UserQrVcard

const QRContainer = styled.div`
  padding: ${dimens.SPACING_XXS};
`
const Image = styled.img`
  position: absolute;
  width: 100%;
`

const Wrapper = styled.div`
  position: relative;
`
